import { BetAccountHolder } from '@mobi/api-types'
import { get } from '@classic/Foundation/Services/ApiService'

export const getContactDetails = () => get<BetAccountHolder>({ url: '/api/contactDetails' })
